var AreaMeasurementConfiguration = /** @class */ (function () {
    function AreaMeasurementConfiguration(config) {
        /**
         * Class that determines which icon is used for the button.
         *
         * @Default 'esri-icon-minus'
         */
        this.iconClass = 'esri-icon-polyline';
        /**
         * The threshold distance used by the "auto" mode to switch between planar and geodesic linear computations. The threshold is measured in meters.
         *
         * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-AreaMeasurement2D-AreaMeasurement2DViewModel.html#geodesicDistanceThreshold)
         *
         */
        this.geodesicDistanceThreshold = 100000;
        /**
         * Unit system (imperial, metric) or specific unit used for displaying the area values.  **Possible Values:** metric | imperial | inches | feet | us-feet | yards | miles | nautical-miles | meters | kilometers
         *
         * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-AreaMeasurement2D-AreaMeasurement2DViewModel.html#unit)
         */
        this.unit = 'square-miles';
        if (config) {
            Object.assign(this, config);
        }
    }
    return AreaMeasurementConfiguration;
}());
export default AreaMeasurementConfiguration;
export var AreaMeasureConfigurationConverter = function (value) {
    if (typeof value === 'string') {
        return new AreaMeasurementConfiguration(JSON.parse(value));
    }
    return value;
};
